<template>
    <div class="alert alert-secondary mt-3">
        <h6>404</h6>
        <p>{{ message }}</p>
        <router-link to="/">{{ $t('notFound.backHome') }}</router-link>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
    props: {
        item: String,
    },
    computed: {
        message() {
            return this.$t('notFound.message', { item: this.item || this.$t('notFound.fallback') });
        }
    }
};
</script>

<style>

</style>